<template>
  <div>
    <div class="w-full max-w-xs mdmax:w-full mb-6">
      <div class="date-range relative text-xs shadow-sm">
        <div class="absolute left-3 top-1/2 transform -translate-y-1/2 z-1">
          <Calendar color="neutral-700" />
        </div>
        <date-range-picker v-model="dateRange" :locale-data="{ format: 'dd/mm/yyyy', separator: ' - ' }"
          @update="setDate" :showDropdowns="false" :timePicker="false" :timePicker24Hour="false"
          :ranges="false"></date-range-picker>
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat Invoice" :url="`/invoice/detail/${entry.id}`"
          linkType="internal" type="secondary" size="small" />
        <LinkButton v-if="column.field === 'action'" buttonText="Mark as Paid" :url="`/invoice/detail/${entry.id}`"
          linkType="internal" type="primary" size="small" class="ml-2"/>
        <span class="block" v-else-if="column.field === 'created_at'">
          {{ entry[column.field] | formatDate }}
        </span>
        <span class="block break-all" v-else-if="column.field === 'id'">
          {{ entry[column.field] }}
        </span>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker"
import "vue2-daterange-picker/dist/vue2-daterange-picker.css"
import dayjs from "dayjs"
const NOW = new Date()

export default {
  components: {
    DateRangePicker,
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    // Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Calendar: () => import(/* webpackChunkName: "Forms" */ "@/components/Icons/Calendar"),
    // Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')\
  },
  data: () => ({
    columns: [
      { label: 'Invoice Number', field: 'invoice_number' },
      { label: 'Total Invoice Amount', field: 'invoice_amount' },
      { label: 'Status', field: 'status' },
      { label: 'Created Date', field: 'created_at' },
      { label: 'Action', field: 'action' },
    ],
    data: [
      {
        id: 1,
        invoice_number: '003/INV/V/24',
        invoice_amount: 150.000,
        status: 'Lunas',
        created_at: '08/11/20024'
      },
      {
        id: 2,
        invoice_number: '004/INV/V/24',
        invoice_amount: 75.000,
        status: 'Pending',
        created_at: '12/04/20024'
      },
      {
        id: 3,
        invoice_number: '005/INV/V/24',
        invoice_amount: 225.000,
        status: 'Lunas',
        created_at: '29/06/20024'
      },
    ],
    dateRange: {
      startDate: new Date(NOW.getFullYear(), NOW.getMonth(), NOW.getDate() - 7),
      endDate: NOW
    },
    queries: {
      page: 1,
      per_page: 10,
      start_date: "",
      end_date: "",
      status: "ALL",
    },
  }),
  computed: {
    filteredData() {
      let temp = this.data || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
  },
  methods: {
    setDate(value) {
      this.queries.start_date = dayjs(String(value.startDate)).format(
        "YYYY-MM-DD"
      )
      this.queries.end_date = dayjs(String(value.endDate)).format("YYYY-MM-DD")
      this.$router.push({ query: this.queries })
    },
  },
}
</script>
<style lang="scss" scoped>
.date-range {
  &::v-deep .reportrange-text {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
  }

  &::v-deep .vue-daterange-picker {
    display: block;
  }
}
</style>